function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51.85 40.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-324.22,136.28l-8.54-8.56a2.22,2.22,0,0,0-3.08,0,2.2,2.2,0,0,0-.64,1.55,2.18,2.18,0,0,0,.64,1.55l8.54,8.54a4.36,4.36,0,0,0,3.09,1.29,4.34,4.34,0,0,0,3.08-1.29L-301,119.19a2.18,2.18,0,0,0,.65-1.54,2.18,2.18,0,0,0-.65-1.54,2.15,2.15,0,0,0-1.54-.64,2.17,2.17,0,0,0-1.54.64Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -347.39,
    y: 182.4,
    width: 55.37,
    height: 55.37,
    rx: 7.91,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -249.69,
    cy: 210.08,
    r: 28.2,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.24,0H9.6A9.62,9.62,0,0,0,0,9.6V31.22a9.62,9.62,0,0,0,9.6,9.61H42.24a9.62,9.62,0,0,0,9.61-9.61V9.6A9.62,9.62,0,0,0,42.24,0Zm0,4a5.58,5.58,0,0,1,3.88,1.57L27.77,21.87a2.62,2.62,0,0,1-3.7,0h0L5.72,5.57A5.59,5.59,0,0,1,9.6,4Zm5.61,27.22a5.62,5.62,0,0,1-5.61,5.61H9.6A5.61,5.61,0,0,1,4,31.22V9.6A5.63,5.63,0,0,1,4,9L22,25a5.56,5.56,0,0,0,7.85,0l18-16a5.65,5.65,0,0,1,0,.58Z",
    style: {
      fill: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d44ca041.svg";
export { ForwardRef as ReactComponent };